<script>
import _get from 'lodash/get'

export default {
  name: 'Get',

  props: {
    object: {
      required: true
    },
    get: {
      required: true
    }
  },

  computed: {
    found() {
      return _get(this.object, this.get)
    }
  },

  render() {
    return this.$scopedSlots.default({
      found: this.found
    })
  },

}
</script>
